import { css } from '@emotion/react';

export const GoogleButtonCss = css`
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.3s ease;
	background-color: var(--white) !important;
	border: 1px solid var(--blue) !important;

	> .typography {
		color: var(--blue) !important;
	}

	:hover {
		color: var(--blue-hover) !important;
		border: 1px solid var(--blue-hover) !important;
		filter: brightness(1.2);
	}
`;
